const getFileNameFromPath = (url = "") => {
  const fullFileName = url.split(/[\\/]/).pop() || null;
  if (!fullFileName) {
    return { fileName: null, fileType: null, fullFileName: null };
  }
  const [fileType, ...restOfFile] = fullFileName.split(".").reverse();
  const fileName = restOfFile.join(".");

  return { fileName, fileType, fullFileName };
};

export default getFileNameFromPath;
